module.exports = "<svg id=\"__1Dm1det__cda88051-f769-4460-8ba3-168521fafddc\" data-name=\"Cafe\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M25.51,12.31v11h0A11.43,11.43,0,0,1,14.32,35,11.43,11.43,0,0,1,3.12,23.31h0v-11Zm0,11.33h3.58a3.73,3.73,0,1,0,0-7.45H25.49ZM12,8.13a2.55,2.55,0,0,0,0-3.84A2.22,2.22,0,0,1,12,1m4.71,7.15a2.55,2.55,0,0,0,0-3.84,2.22,2.22,0,0,1,0-3.31\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donauhof-cafe.svg
// module id = 402
// module chunks = 1